/* STORE */
import { createPinia, mapState, mapWritableState, PiniaVuePlugin } from 'pinia'
import vClickOutside from 'v-click-outside'

import stepsComputed from '../common/computed/steps'
import created from '../common/created'
import accountData from '../common/data/account'
import data from '../common/data/generic'
import accountMethods from '../common/methods/account'
import methods from '../common/methods/generic'
import mounted from '../common/mounted'
import useGenericStore from '../common/store/generic'
import validation from '../common/validations/account'
import {
  EmptyTheFields, InformationsValidAndFull, MissingInformations, ValidationErrors
} from '../components/Actions/action'
import AlertValidationErrors from '../components/AlertValidationErrors'
import ResumeTippy from '../components/Base/ResumeTippy'
import MyLoader from '../components/MyLoader'
import { Vue } from './vue'

Vue.use(PiniaVuePlugin)
Vue.directive('click-outside', vClickOutside.directive)

const pinia = createPinia()

export { Vue }

export default {
  pinia,
  components: {
    AlertValidationErrors,
    MyLoader,
    EmptyTheFields,
    InformationsValidAndFull,
    MissingInformations,
    ValidationErrors,
    ResumeTippy
  }, ...created, ...mounted,
  computed: {
    ...stepsComputed, ...validation.computed, ...mapWritableState(useGenericStore, [
      'visibleToastr', 'visibleModal'
    ]), ...mapState(useGenericStore, ['toastr', 'modalNames'])
  },
  data () {
    return {
      ...data, ...accountData
    }
  },
  methods: {
    ...methods, ...accountMethods
  }
}
